import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GitlabFilledSvg from "@ant-design/icons-svg/es/asn/GitlabFilled";
import AntdIcon from "../components/AntdIcon";
var GitlabFilled = function GitlabFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GitlabFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GitlabFilled.displayName = 'GitlabFilled';
}
export default /*#__PURE__*/React.forwardRef(GitlabFilled);